import { useCallback, useContext, useState } from "react";
import NotificationContext from "../context/NotificationContext";

const useNotification = () => {  
    const context = useContext(NotificationContext);
    if (!context) throw new Error('[x] useNotification не обнаружил NotificationProvider');
    return context;
  };

export default useNotification;